//import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
//import { API_BASE_URL } from '../constants';

import { apiSlice } from '../app/api/apiSlice';

export const jobsAdminToolsAuxApi = apiSlice.injectEndpoints({
  tagTypes: ['JobsAux'],
  endpoints: (builder)=>({
    jobsAdminToolsAux: builder.mutation({
      query: (filter)=>{
        console.log("jobsAdminToolsAuxApi: ", JSON.stringify(filter))
        return{
          url: 'jobs/admin-tools',
          method: 'post',
          body: filter
        }
      },
      providesTags: ['JobsAux']
    }),
  })
})

export const { useJobsAdminToolsAuxMutation } = jobsAdminToolsAuxApi;